const s=":host [slot=icon]{--md-icon-size: var(--_icon-size)}";export{s as default};
